<template lang="html">
	<div class="notifications-panel-container" :class="{active: active}" @click="setActive">
		<section class="notification-panel" @click.stop>
	  	<div class="head row">
	  		<span class="icon-volet-notif"></span>
				<div class="label">
					Notifications
				</div>
				<span class="close icon-form-close" @click="setActive"></span>
	  	</div>
			<div class="day">
				{{ new Date() | moment('dddd DD MMMM') }}
			</div>
			<div class="ctn-notifications">
				<div class="notification" v-for="notification in notifications">
					<div class="head-notif row" v-if="notification.type === 'article'">
						<span class="icon-notif-article"></span>
						<div class="label">Nouvel Article</div>
						<div class="hour">{{ notification.date | moment('HH[h]mm') }}</div>
					</div>
					<div class="body-notif">
						{{ notification.text }}
					</div>
				</div>
			</div>
	  </section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'NotificationPanel',
	props: ['active'],
	methods: {
		setActive () {
			this.$emit('notif-close')
		}
	},
	computed: {
		...mapGetters({
			notifications: 'notifications'
		})
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// notification-panel.vue?babb53c8